<template>
  <div class="md-layout page-airport">
    <md-card style="min-height: 30px; margin-top: 0;">
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-10 md-form-label">
            <label>{{ $t("Start Time") }}</label>
          </div>
          <div class="md-layout-item md-size-20">
            <md-field>
              <datetime
                input-class="md-input"
                v-model="startDate"
                value-zone="local"
                required
              />
            </md-field>
          </div>
          <div class="md-layout-item md-size-10 md-form-label">
            <label>{{ $t("End Time") }}</label>
          </div>
          <div class="md-layout-item md-size-20">
            <md-field>
              <datetime
                input-class="md-input"
                v-model="endDate"
                value-zone="local"
                required
              />
            </md-field>
          </div>
          <md-button slot="footer" class="md-primary" @click="handleSubmit">{{
            $t("Submit")
          }}</md-button>
        </div>
      </md-card-content>
    </md-card>
    <div id="airportMap"></div>
    <md-button
      class="md-icon-button surveys-btn md-primary"
      @click="showSidepanel = true"
    >
      <md-icon>menu</md-icon>
    </md-button>
    <md-drawer class="md-right" :md-active.sync="showSidepanel">
      <md-toolbar class="md-transparent">
        {{ $t("Missions") }}
      </md-toolbar>

      <div v-if="(airportDailySurveys || []).length === 0" class="no-data">
        {{ $t("No missions available in the selected date range") }}
      </div>
      <md-list :md-expand-single="true">
        <md-list-item
          md-expand
          :md-expanded="
            showSidepanel && lastSelectedMission.id === item._id.$oid
          "
          :md-expand-single="true"
          v-for="(item, position) in airportDailySurveys || []"
          :key="position"
        >
          <b>
            {{ $t("Pilot Name") }}:
            {{ item.pilotname }}
          </b>

          <md-list slot="md-expand">
            <div class="survey-list-item" :id="`mission-${item._id.$oid}`">
              <div class="mb-10">
                <a class="link" @click="flyTo(item)">{{
                  $t("view on the map")
                }}</a>
              </div>
              <div v-if="item.mission_reference_no">
                {{ $t("Reference No") }}:
                {{ item.mission_reference_no }}
              </div>
              <div>
                {{ $t("Pilot Email") }}:
                <a
                  v-if="item.pilotemail || item.email"
                  class="link"
                  target="_blank"
                  :href="`mailto: ${item.pilotemail || item.email}`"
                >
                  {{ item.pilotemail || item.email }}
                </a>

                <span
                  v-if="item.pilotemail || item.email"
                  v-clipboard="item.pilotemail || item.email"
                  class="material-icons copy-icon"
                  v-clipboard:success="clipboardCbfn"
                >
                  content_copy
                </span>

                <span v-else>--</span>
              </div>
              <div>
                {{ $t("Pilot Phone") }}:
                <a
                  v-if="item.pilotphone"
                  class="link"
                  target="_blank"
                  :href="`tel: ${item.pilotphone}`"
                >
                  {{ item.pilotphone }}
                </a>
                <span
                  v-if="item.pilotphone"
                  v-clipboard="item.pilotphone"
                  class="material-icons copy-icon"
                  v-clipboard:success="clipboardCbfn"
                >
                  content_copy
                </span>
                <span v-else>--</span>
              </div>
              <div>
                {{ $t("Drone Model") }}:
                {{ item.manufacturer }}
                {{ item.rpas }}
              </div>
              <div>
                {{ $t("Start Time") }}:
                {{
                  new Date(item.events[0].start.$date).toLocaleString("en-US")
                }}
              </div>
              <div>
                {{ $t("End Time") }}:
                {{ new Date(item.events[0].end.$date).toLocaleString("en-US") }}
              </div>
            </div>
          </md-list>
        </md-list-item>
      </md-list>
    </md-drawer>
    <Toast ref="toast"></Toast>
  </div>
</template>
<script>
import { EventBus, getRandomColor, createGeoJSONCircle } from "@/helpers";
import { mapFields } from "vuex-map-fields";
import { mapboxAccessToken } from "@/const";
import moment from "moment";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Toast from "@/components/Toast.vue";
import { Clipboard } from "v-clipboard";

export default {
  components: {
    Toast
  },
  data() {
    return {
      map: null,
      alert: false,
      latitude: 43.4723,
      longitude: -80.5449,
      startDate: null,
      endDate: null,
      geometry: {},
      showSidepanel: false,
      lastSelectedMission: {}
    };
  },
  computed: {
    ...mapFields("setting", []),
    ...mapFields("auth", ["airport_id"]),
    ...mapFields("survey", ["airportDailySurveys"]),
    ...mapFields("airport", ["airport"])
  },
  mounted() {
    this.startDate = moment(new Date()).format("YYYY-MM-DD");
    this.endDate = moment(new Date()).format("YYYY-MM-DD");

    if (this.airport_id) {
      this.$store.dispatch("airport/getAirport", {
        airportId: this.airport_id
      });
    }

    EventBus.$on("setAirport", () => {
      this.geometry = this.airport.sfcData;
      this.latitude = this.airport.properties.LATITUDE;
      this.longitude = this.airport.properties.LONGITUDE;
      this.loadMap();
    });

    EventBus.$on("setAirportDailySurveys", () => {
      this.loadMissions();
    });

    document.addEventListener("click", this.MapElementClick);
  },
  beforeDestroy() {
    this.map.remove();
    EventBus.$off("setAirport");
    EventBus.$off("setAirportDailySurveys");
    document.removeEventListener("click", this.MapElementClick);
  },
  watch: {
    airport_id(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.$store.dispatch("airport/getAirport", {
        airportId: this.airport_id
      });
    }
  },
  methods: {
    handleSubmit() {
      this.$store.dispatch("survey/getAirportDailySurveys", {
        airportId: this.airport_id,
        startDate: moment(this.startDate).toDate(),
        endDate: moment(this.endDate).toDate()
      });
    },
    loadMap() {
      var self = this;

      var createGeoJSON = function(geometry) {
        return {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              properties: {},
              geometry: {
                type: "Polygon",
                coordinates: geometry[0].geometry.coordinates
              }
            }
          ]
        };
      };
      mapboxgl.accessToken = mapboxAccessToken;
      this.map = new mapboxgl.Map({
        container: "airportMap",
        style: "mapbox://styles/mapbox/satellite-streets-v11",
        center: [this.longitude, this.latitude],
        zoom: 12
      });

      this.map.on("load", function() {
        // get surveys by start & end time
        self.$store.dispatch("survey/getAirportDailySurveys", {
          airportId: self.airport_id,
          startDate: moment(self.startDate).toDate(),
          endDate: moment(self.endDate).toDate()
        });

        // draw airport
        this.addSource("airspace", {
          type: "geojson",
          data: createGeoJSON(self.geometry)
        });
        this.addLayer({
          id: "airspacefills",
          type: "line",
          source: "airspace",
          layout: {},
          paint: {
            "line-color": "red",
            "line-width": 2
          }
        });
      });

      // location of the feature, with description HTML from its properties.
      this.map.on("click", "fills", e => {
        self.removeLastSelectedBorder();
        self.lastSelectedMission = e.features[0].properties;
        this.poopup = new mapboxgl.Popup()
          .setLngLat(e.lngLat)
          .setHTML(
            `<div>
              <b>
                ${self.$t("Pilot Name")}:
                ${e.features[0].properties.pilotname}
              </b>
              </div>
              <div>
                <a class="linkToMissionList">${self.$t("view in the list")}</a>
              </div>
              <div   style="display: ${
                e.features[0].properties.mission_reference_no ? "block" : "none"
              }">
                ${self.$t("Reference No")}: 
                ${e.features[0].properties.mission_reference_no}
              </div>
              <div>
                ${self.$t("Pilot Email")}: 
                <a  style="display: ${
                  e.features[0].properties.email ? "inline" : "none"
                }" target="_blank" href="mailto:${
              e.features[0].properties.email
            }">${e.features[0].properties.email}</a>
              <span
              style="display: ${
                e.features[0].properties.email ? "inline" : "none"
              }"
              class="material-icons copy-icon copy-email"
              >
                  content_copy
                </span>
                <span style="display: ${
                  e.features[0].properties.email ? "none" : "inline"
                }">--</span>
              </div>
              <div>
                ${self.$t("Pilot Phone")}: 
                <a style="display: ${
                  e.features[0].properties.phone ? "inline" : "none"
                }" target="_blank" href="tel:${
              e.features[0].properties.phone
            }">${e.features[0].properties.phone}</a>
            <span
              style="display: ${
                e.features[0].properties.phone ? "inline" : "none"
              }"
              class="material-icons copy-icon copy-phone"
              >
                  content_copy
                </span>
                <span style="display: ${
                  e.features[0].properties.phone ? "none" : "inline"
                }">--</span>
              </div>
              <div>
                ${self.$t("Drone Model")}: 
                ${e.features[0].properties.manufacturer}
                ${e.features[0].properties.model}
              </div>
              <div>
                ${self.$t("Start Time")}: 
                ${e.features[0].properties.start}
              </div>
              <div>
                ${self.$t("End Time")}: 
                ${e.features[0].properties.end}
              </div>`
          )
          .addTo(this.map);
      });

      // Change the cursor to a pointer when the mouse is over the fills layer.
      this.map.on("mouseenter", "fills", () => {
        this.map.getCanvas().style.cursor = "pointer";
      });

      // Change it back to a pointer when it leaves.
      this.map.on("mouseleave", "fills", () => {
        this.map.getCanvas().style.cursor = "";
      });
    },
    loadMissions() {
      if (this.map.getLayer("fills")) {
        this.map.removeLayer("fills");
        this.map.removeSource("surveys");
      }
      var features = this.airportDailySurveys.map(i => {
        var obj = { type: "Feature" };
        obj.properties = {
          pilotname: i.pilotname,
          email: i.pilotemail || i.email,
          phone: i.pilotphone,
          manufacturer: i.manufacturer,
          model: i.rpas,
          mission_reference_no: i.mission_reference_no,
          start: new Date(i.events[0].start.$date).toLocaleString("en-US"),
          end: new Date(i.events[0].end.$date).toLocaleString("en-US"),
          color: getRandomColor(),
          id: i._id.$oid
        };
        obj.geometry = createGeoJSONCircle(
          { lng: i.longitude, lat: i.latitude },
          Number(
            i.radiusunit === "nm" ? i.operationradius * 1852 : i.operationradius
          )
        ).features[0].geometry;
        return obj;
      });
      if (features.length > 0) {
        this.map.addSource("surveys", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: features
          }
        });

        this.map.addLayer({
          id: "fills",
          type: "fill",
          source: "surveys",
          layout: {},
          paint: {
            "fill-color": ["get", "color"],
            "fill-opacity": 0.5
          }
        });
      }
    },
    removeLastSelectedBorder() {
      if (this.map.getLayer("borders")) {
        this.map.removeLayer("borders");
      }
      if (this.map.getSource("currentArea")) {
        this.map.removeSource("currentArea");
      }
    },
    flyTo(item) {
      this.showSidepanel = false;
      this.map.flyTo({
        center: [item.longitude, item.latitude],
        essential: true, // for animation smooth
        zoom: 14
      });
      // add border
      this.removeLastSelectedBorder();
      this.map.addSource("currentArea", {
        type: "geojson",
        data: createGeoJSONCircle(
          { lng: item.longitude, lat: item.latitude },
          Number(
            item.radiusunit === "nm"
              ? item.operationradius * 1852
              : item.operationradius
          )
        )
      });
      this.map.addLayer({
        id: "borders",
        type: "line",
        source: "currentArea",
        layout: {},
        paint: {
          "line-color": "#FFF",
          "line-width": 2
        }
      });
    },
    async MapElementClick(event) {
      // show mission list
      if (event.target.classList.contains("linkToMissionList")) {
        this.poopup.remove();
        this.showSidepanel = true;
        // scroll to the view
        const targetEle = document.querySelector(
          `#mission-${this.lastSelectedMission.id}`
        );
        targetEle.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest"
        });
      } else if (event.target.classList.contains("copy-phone")) {
        await Clipboard.copy(this.lastSelectedMission.phone);
        this.clipboardCbfn();
      } else if (event.target.classList.contains("copy-email")) {
        await Clipboard.copy(this.lastSelectedMission.email);
        this.clipboardCbfn();
      }
    },
    clipboardCbfn() {
      this.$refs.toast.showToast(this.$t("Copied"));
    }
  }
};
</script>
<style lang="css">
.page-airport {
  position: relative;
  .copy-icon {
    color: #0abab5;
    font-size: 14px;
    margin-left: 8px;
    cursor: pointer;
    position: relative;
    top: 4px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .linkToMissionList {
    display: block;
    margin: 10px 0;
    cursor: pointer;
  }

  .no-data {
    text-align: center;
    margin-top: 20px;
    font-size: 14px;
    color: #999;
  }

  .survey-list-item {
    height: auto;
    padding: 0 16px;
    font-size: 12px;
    line-height: 21px;
    .link {
      display: inline;
      color: #0abab5 !important;
      cursor: pointer;
      text-transform: lowercase;
    }
  }
  .surveys-btn {
    position: absolute;
    top: 110px;
    right: 16px;
    padding: 6px 8px;
  }
}
#airportMap {
  width: 100%;
  height: 85vh;
  margin: 0;
  padding: 0;
}

label {
  display: inline-block;
  margin-right: 10px;
}

input[type="date"] {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-right: 10px;
}

button[type="submit"] {
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

button[type="submit"]:hover {
  background-color: #0056b3;
}
</style>
